import React from 'react';
import { MoreActionsItems, MoreActionsV2 } from '@css-xp/base';
import { useCreditNotePoller } from '@css-xp/ppc-refund-table';

export const RefundDetailsPageActionsV2 = ({
  creditNoteId,
  transactionAccountId,
}: {
  creditNoteId: string;
  transactionAccountId: string;
}) => {
  const { handleCreditNoteDownload, isDownloadingPdf } = useCreditNotePoller(creditNoteId, transactionAccountId);
  const actions: MoreActionsItems[] = [
    {
      id: 'export-as-pdf',
      content: 'Export as PDF',
      action: async () => {
        handleCreditNoteDownload(creditNoteId);
      },
    },
  ];

  return (
    <MoreActionsV2
      actions={actions}
      appearance="default"
      trigger="Manage"
      ariaLabel="menu"
      isLoading={isDownloadingPdf}
    />
  );
};
